import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">
    <path d="M0 6270 l0 -6270 6270 0 6270 0 0 6270 0 6270 -6270 0 -6270 0 0
-6270z m6585 4635 c645 -68 1228 -304 1755 -711 148 -115 441 -406 562 -559
277 -351 469 -712 606 -1135 209 -648 225 -1352 47 -2035 -182 -697 -562
-1333 -1063 -1781 -52 -46 -108 -93 -125 -105 l-32 -21 30 27 c17 15 54 48 84
73 52 46 140 132 211 206 34 36 34 38 16 52 -11 8 -15 14 -10 14 6 0 16 -6 23
-12 11 -11 13 -10 8 5 -4 9 -2 18 3 18 6 1 15 2 21 3 6 0 28 21 47 46 20 25
30 39 22 32 -16 -14 -34 -16 -26 -4 3 5 -5 8 -17 7 -15 -1 -21 -8 -19 -20 2
-11 -1 -14 -8 -10 -7 4 -9 16 -7 27 5 16 3 17 -10 6 -15 -12 -15 -11 -4 9 6
13 20 27 31 33 11 6 20 17 20 25 0 8 5 15 11 15 6 0 8 -9 4 -21 -5 -15 -4 -19
4 -15 6 4 11 13 11 21 0 8 8 19 18 24 9 6 12 11 6 11 -5 0 -15 -5 -22 -12 -7
-7 -12 -8 -12 -3 0 17 57 75 65 67 5 -4 5 -1 1 6 -5 8 -1 21 10 33 9 10 12 19
7 19 -6 0 -13 -6 -16 -12 -13 -34 -158 -199 -297 -339 -208 -209 -401 -362
-629 -498 -364 -218 -778 -369 -1183 -430 -628 -96 -1289 6 -1887 290 -345
164 -630 367 -916 654 -288 288 -469 540 -645 900 -219 450 -326 866 -349
1365 -36 764 187 1547 615 2167 35 51 64 96 64 100 0 4 -7 -3 -16 -15 -13 -20
-18 -21 -32 -10 -15 12 -16 11 -3 -4 11 -14 11 -21 1 -33 -7 -8 -17 -12 -23
-8 -6 4 -7 1 -3 -6 8 -13 -20 -51 -37 -51 -6 0 -2 9 8 20 22 24 30 60 14 60
-5 0 -7 5 -4 10 4 6 11 8 16 5 5 -3 6 1 3 9 -8 21 23 51 39 38 22 -17 48 -9
70 22 26 39 139 170 150 174 4 2 7 8 7 14 0 6 -6 6 -15 -2 -12 -10 -15 -10
-15 1 0 11 -2 11 -9 -1 -6 -8 -7 -18 -5 -22 3 -5 -8 -23 -25 -40 -19 -20 -31
-26 -31 -17 0 12 -2 12 -9 0 -5 -8 -7 -20 -4 -27 2 -7 -5 -17 -16 -24 -12 -6
-21 -17 -21 -24 0 -19 -37 -50 -45 -37 -8 14 3 33 16 26 5 -4 9 -2 9 4 0 5 3
18 6 28 5 17 5 17 -9 1 -16 -20 -37 -24 -37 -6 0 6 -10 3 -21 -8 -21 -18 -20
-17 2 18 18 28 27 34 37 26 7 -6 16 -7 20 -3 4 4 1 10 -5 12 -7 3 -13 9 -13
14 0 6 4 7 10 4 5 -3 8 0 5 7 -2 7 5 24 16 37 19 23 20 23 40 5 19 -17 20 -17
13 1 -6 14 -4 17 9 12 9 -3 19 -1 23 5 4 6 3 8 -4 4 -6 -3 -13 -2 -17 4 -3 5
-11 10 -16 10 -6 0 -7 -6 -3 -12 6 -10 4 -10 -8 0 -14 11 -24 2 -78 -65 -34
-42 -72 -93 -85 -113 -22 -35 -55 -68 -55 -56 0 16 156 221 239 315 403 455
923 804 1481 993 468 158 963 219 1405 173z m-3170 -1566 c-14 -24 -44 -73
-65 -108 -22 -34 -40 -66 -40 -70 0 -5 -9 -18 -19 -30 -11 -12 -27 -32 -35
-44 -16 -22 -17 -22 -5 3 35 75 178 304 185 297 3 -2 -7 -24 -21 -48z m42 -35
c3 -8 12 -13 20 -10 11 5 13 1 7 -17 -4 -12 -10 -24 -13 -27 -4 -3 -14 -20
-23 -39 -16 -34 -26 -31 -34 14 -6 33 14 74 27 54 7 -12 9 -11 9 2 0 8 -5 20
-12 27 -9 9 -9 12 0 12 7 0 15 -7 19 -16z m-47 -29 c-7 -9 -15 -13 -18 -10 -3
2 1 11 8 20 7 9 15 13 18 10 3 -2 -1 -11 -8 -20z m10 -102 c0 -9 -61 -117 -69
-123 -4 -3 -13 -20 -20 -38 -8 -18 -18 -35 -23 -38 -7 -4 -7 0 0 12 5 11 13
36 16 58 5 26 14 40 27 43 21 6 25 18 9 28 -5 3 -10 11 -10 16 0 6 4 8 9 5 5
-4 12 0 15 6 3 7 3 2 0 -12 -5 -24 -4 -24 10 -6 19 24 20 43 4 49 -7 3 -3 6
10 6 12 1 22 -2 22 -6z m-83 -25 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m-34 -143 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z
m-118 -57 c-10 -13 -14 -16 -11 -8 3 8 9 24 13 35 4 11 8 14 11 7 2 -6 -4 -22
-13 -34z m49 -130 c-9 -18 -19 -27 -21 -21 -3 7 3 20 11 29 9 8 16 20 16 26 0
6 3 9 6 6 3 -4 -2 -21 -12 -40z m-329 -604 c-74 -306 -105 -564 -105 -879 1
-603 122 -1110 396 -1653 101 -202 108 -225 18 -62 -222 403 -360 853 -416
1350 -7 64 -12 228 -12 370 0 336 25 545 104 855 16 66 30 122 30 124 0 2 2 2
5 0 2 -3 -7 -50 -20 -105z m5855 -3214 c0 -19 -18 -19 -23 -1 -3 14 -1 18 9
14 8 -3 14 -9 14 -13z m-70 0 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10
11 10 2 0 4 -4 4 -10z m-465 -530 c-3 -5 -16 -15 -28 -21 -19 -9 -19 -8 3 10
28 23 34 26 25 11z m1166 -1055 c24 -9 52 -14 62 -11 15 4 17 -4 17 -62 0 -37
3 -77 6 -89 4 -13 2 -23 -4 -23 -5 0 -12 12 -15 28 -14 69 -96 122 -189 122
-71 0 -117 -29 -137 -86 -28 -81 11 -133 164 -220 105 -59 176 -118 202 -169
38 -72 9 -187 -65 -257 -19 -18 -31 -26 -27 -18 5 8 17 21 27 28 25 18 58 85
58 117 0 24 -1 25 -16 11 -20 -21 -21 -21 -38 12 l-15 27 -1 -25 c-1 -22 -4
-19 -20 16 -22 49 -78 96 -185 154 -100 55 -168 117 -183 169 -37 121 20 235
137 277 50 18 169 17 222 -1z m-7676 -30 c77 -39 105 -79 105 -152 0 -59 -15
-97 -51 -128 l-23 -20 20 30 c12 17 24 39 28 50 5 16 2 15 -14 -5 -12 -15 -18
-18 -14 -7 7 19 -12 24 -19 5 -3 -7 -6 1 -6 17 -1 23 -4 27 -11 15 -8 -12 -10
-12 -10 5 0 11 -9 -4 -20 -34 -20 -55 -49 -94 -85 -113 -22 -13 -163 -28 -182
-21 -10 4 -13 38 -13 132 0 146 -19 207 -22 71 l-1 -85 -7 60 c-6 54 -7 56
-10 20 -2 -25 -4 -32 -7 -18 -3 13 -10 20 -18 17 -7 -3 -15 2 -18 13 -3 10 -5
2 -6 -17 -1 -19 -6 -42 -11 -50 -7 -10 -10 18 -10 88 0 110 -9 142 -40 142
-10 0 -22 5 -26 11 -5 8 50 10 202 8 209 -4 209 -4 269 -34z m815 -92 c29 -71
102 -247 162 -393 106 -258 135 -310 174 -310 8 0 14 -4 14 -10 0 -12 0 -12
-36 0 -16 6 -36 21 -45 33 -8 12 -66 144 -128 292 -162 385 -175 415 -179 411
-2 -2 4 -21 13 -42 8 -20 13 -47 10 -58 -5 -15 -3 -17 3 -8 11 16 56 -82 48
-104 -3 -9 -1 -12 4 -9 15 9 12 -8 -6 -33 -15 -22 -17 -22 -30 -5 -12 16 -13
14 -8 -17 9 -47 -7 -30 -35 40 -13 30 -32 74 -42 97 -11 23 -19 49 -19 57 0
31 -26 15 -37 -21 -6 -21 -37 -100 -68 -176 -32 -76 -56 -140 -53 -142 2 -2
67 -5 146 -6 78 -1 142 -6 142 -10 0 -5 -69 -9 -154 -9 l-155 0 9 28 c4 15 13
41 20 59 7 20 8 38 2 48 -7 13 -12 7 -26 -30 -10 -25 -20 -44 -23 -41 -3 2 9
33 26 68 16 35 39 86 50 113 10 28 32 79 48 115 17 36 41 93 54 128 19 48 28
62 45 62 17 0 30 -23 74 -127z m797 35 c23 -51 66 -145 97 -208 103 -216 154
-335 148 -345 -3 -5 -20 22 -38 60 -93 204 -115 247 -120 242 -3 -3 4 -23 15
-46 28 -54 62 -141 55 -141 -3 0 -10 13 -15 30 -6 16 -15 27 -20 24 -5 -3 -14
5 -19 18 -10 22 -10 22 -7 -4 5 -36 -10 -26 -18 12 -4 17 -11 30 -16 30 -13 0
-10 -31 6 -60 8 -14 14 -32 14 -40 0 -16 -7 -2 -132 245 -42 83 -76 146 -76
140 -4 -210 -6 -636 -3 -654 3 -15 17 -28 38 -37 41 -17 44 -27 7 -18 -62 14
-63 19 -65 328 -1 154 -4 247 -7 206 l-6 -75 -7 85 c-5 47 -8 117 -8 155 0 96
-7 115 -42 122 -64 13 -33 23 69 23 l109 0 41 -92z m748 82 c-3 -5 -14 -10
-24 -10 -40 0 -41 -10 -41 -391 0 -355 1 -367 21 -393 11 -14 29 -26 40 -26
10 0 19 -4 19 -9 0 -9 -48 0 -69 14 -22 13 -31 89 -33 280 -2 174 -3 185 -7
86 -6 -109 -7 -114 -23 -97 -10 10 -18 25 -19 34 0 9 -6 4 -12 -13 l-12 -30
-6 40 c-6 38 -6 36 -9 -20 l-3 -60 -7 70 c-4 39 -8 143 -9 232 0 96 -5 164
-11 168 -5 3 -10 2 -10 -3 0 -5 -22 -56 -49 -113 -66 -142 -93 -201 -167 -369
-92 -206 -98 -220 -106 -220 -12 0 -11 2 37 101 29 59 43 100 39 112 -4 12 -2
17 4 13 6 -4 8 3 5 16 -3 17 -2 19 5 10 7 -11 11 -8 17 10 4 12 7 32 6 43 0
13 2 15 6 6 4 -9 10 -3 19 19 8 18 12 35 9 38 -3 3 -5 0 -5 -7 0 -7 -4 -9 -10
-6 -6 4 -7 -1 -3 -11 4 -11 2 -15 -4 -11 -6 4 -24 -23 -41 -61 -18 -37 -32
-60 -32 -52 0 23 92 220 100 215 4 -3 7 1 6 8 0 6 11 37 26 67 41 84 138 310
138 321 0 5 48 9 111 9 71 0 108 -4 104 -10z m729 -178 c44 -103 111 -261 149
-352 37 -91 78 -186 89 -212 21 -48 53 -78 83 -78 8 0 15 -5 15 -10 0 -12 -48
-3 -67 12 -7 5 -18 6 -24 2 -8 -4 -9 -3 -5 4 4 6 -2 29 -13 51 -11 21 -34 75
-51 118 -17 43 -42 101 -54 128 -13 28 -27 60 -31 73 -4 13 -9 21 -12 19 -5
-6 38 -124 66 -179 15 -29 16 -38 6 -38 -8 0 -19 16 -26 35 -7 19 -16 30 -20
24 -3 -6 -11 3 -17 20 -8 22 -15 29 -27 25 -10 -4 -14 -1 -12 7 2 8 2 11 0 7
-17 -31 -36 4 -137 247 -23 55 -46 101 -51 102 -6 2 -25 -32 -43 -75 -37 -86
-102 -256 -102 -266 0 -3 63 -6 139 -6 83 0 142 -4 146 -10 4 -6 -45 -11 -137
-12 l-143 -2 150 -6 150 -6 -165 -2 c-109 -1 -160 2 -150 8 9 6 10 10 3 10 -6
0 -14 10 -16 23 -3 17 -5 16 -6 -8 -1 -16 -17 -75 -36 -129 -19 -55 -35 -109
-35 -121 0 -26 18 -45 42 -45 10 0 18 -5 18 -11 0 -11 -37 -3 -57 13 -21 17
-15 68 22 172 19 55 35 109 34 120 0 21 -1 21 -9 1 -5 -11 -9 -15 -9 -9 -1 6
41 109 92 230 52 120 102 240 113 266 14 35 24 48 39 48 16 0 34 -34 99 -188z
m1035 164 c132 -37 228 -114 279 -224 54 -116 38 -293 -36 -391 -43 -58 -58
-72 -43 -44 6 12 16 25 21 28 11 7 32 54 56 123 11 30 12 47 5 60 -7 10 -11
12 -11 4 0 -7 -4 -10 -10 -7 -6 3 -7 -1 -3 -10 5 -14 8 -14 15 -3 7 9 8 8 4
-5 -3 -10 -6 -24 -7 -30 0 -7 -5 -1 -11 13 -9 21 -12 22 -15 8 -4 -16 -6 -16
-20 -3 -16 17 -33 12 -33 -11 0 -8 -4 -14 -8 -14 -5 0 -9 44 -9 98 0 141 -42
235 -134 305 -75 57 -121 70 -249 74 l-115 3 3 -362 c1 -199 5 -365 8 -368 3
-3 56 -5 118 -5 109 0 115 1 182 35 56 29 76 46 108 92 46 67 61 70 22 5 -55
-95 -154 -149 -286 -155 -47 -2 -104 1 -127 7 l-43 12 -1 157 c0 97 -4 149 -9
137 -5 -11 -9 -33 -10 -50 l-2 -30 -8 30 c-4 17 -8 24 -9 17 -1 -10 -6 -10
-21 -2 -17 9 -22 7 -29 -11 -7 -21 -21 244 -21 414 0 75 -15 107 -51 107 -10
0 -21 5 -24 11 -11 17 456 4 524 -15z m932 -53 c18 -43 51 -123 74 -178 24
-55 77 -183 119 -285 111 -269 109 -266 150 -281 20 -7 36 -17 36 -21 0 -12
-52 2 -73 21 -20 17 -22 22 -98 200 -27 63 -53 119 -59 125 -6 6 -4 -6 4 -26
19 -43 20 -58 6 -58 -5 0 -10 9 -10 19 0 11 -5 23 -12 27 -8 5 -9 2 -5 -10 5
-14 3 -15 -13 -6 -25 14 -35 13 -23 -2 6 -7 10 -20 10 -29 0 -8 12 -40 26 -71
15 -31 27 -67 26 -80 -1 -26 -56 88 -66 135 l-5 27 -179 0 -179 0 -6 -26 c-9
-35 -67 -166 -60 -134 4 14 9 36 12 50 5 20 3 22 -6 10 -9 -12 -10 -10 -5 9 6
18 4 22 -6 15 -11 -6 -12 -5 -2 8 22 26 263 602 263 627 0 6 11 11 24 11 21 0
29 -11 57 -77z m1171 -13 c5 -86 3 -108 -7 -74 -26 85 -64 104 -204 104 l-104
0 6 -367 c6 -361 6 -368 28 -385 12 -10 27 -18 35 -18 7 0 16 -5 20 -11 12
-20 -60 1 -78 23 -14 16 -18 41 -19 122 -1 55 -5 128 -9 161 -7 60 -7 60 -9
-30 -2 -85 -3 -88 -16 -60 -7 17 -14 23 -15 15 0 -9 -6 -6 -14 10 l-14 25 -7
-40 c-12 -70 -13 -63 -15 70 -1 72 -3 211 -6 309 l-5 180 -101 -3 c-56 -1
-113 -7 -127 -13 -38 -14 -69 -46 -76 -79 -12 -54 -22 -29 -13 34 5 34 7 73 4
87 l-4 25 373 0 373 1 4 -86z m545 -45 c30 -71 97 -236 150 -365 118 -291 127
-310 164 -323 16 -6 29 -15 29 -19 0 -10 -3 -10 -37 3 -15 6 -59 11 -98 12
l-70 1 63 3 c45 3 62 8 59 16 -33 81 -91 207 -94 204 -2 -2 6 -25 17 -51 25
-59 25 -68 0 -36 -11 14 -19 18 -18 10 5 -26 -27 -16 -44 15 -22 38 -23 18 -2
-34 9 -22 14 -46 12 -52 -2 -7 -21 31 -43 84 l-38 97 -171 0 -171 0 -30 -77
c-36 -99 -39 -164 -7 -178 12 -5 22 -13 22 -18 0 -12 -43 3 -56 19 -7 8 -15
36 -19 62 l-7 47 -23 -45 c-13 -25 -31 -52 -41 -61 -24 -20 -52 -30 -58 -20
-3 4 10 13 29 20 28 10 41 26 78 99 25 48 65 137 90 197 25 61 81 197 126 303
45 106 81 200 81 208 0 11 8 14 26 12 23 -3 32 -18 81 -133z m1478 126 c-6 -5
-19 -11 -29 -13 -32 -5 -38 -57 -34 -337 3 -256 4 -268 27 -314 30 -61 74 -95
144 -109 72 -15 146 1 208 46 81 59 84 72 87 378 2 147 -1 281 -5 299 -7 25
-17 36 -43 45 -32 11 -27 13 68 13 66 1 101 -3 97 -9 -3 -5 -13 -10 -21 -10
-36 0 -44 -60 -44 -318 0 -278 -7 -320 -63 -394 -57 -75 -124 -107 -234 -114
-37 -2 -51 0 -47 9 3 8 23 11 57 9 57 -2 164 35 160 56 -2 7 2 12 9 12 6 0 9
2 6 5 -3 3 -27 -7 -54 -22 -41 -24 -61 -28 -124 -28 -134 0 -213 64 -246 197
-8 36 -13 44 -13 26 -1 -16 -5 -28 -11 -28 -5 0 -10 -8 -10 -17 0 -15 -2 -16
-10 -3 -5 8 -10 13 -11 10 0 -3 -2 -14 -4 -25 -6 -29 3 -52 20 -52 8 0 15 5
15 10 0 5 9 -1 20 -14 l20 -24 -15 37 c-8 21 -15 48 -14 60 1 25 4 19 13 -24
4 -15 27 -53 53 -85 41 -51 43 -54 15 -34 -18 12 -37 19 -43 16 -5 -4 -20 1
-32 11 -12 9 -5 1 15 -19 21 -21 43 -37 50 -36 7 0 3 5 -9 11 -23 11 -31 28
-15 28 13 0 43 -36 37 -42 -4 -3 8 -10 24 -16 38 -14 41 -23 4 -13 -64 19
-101 41 -131 76 -53 65 -60 103 -67 410 -3 154 -9 288 -11 298 -3 10 -20 24
-37 31 -29 13 -21 14 103 15 80 1 130 -3 125 -8z m1130 -6 c67 -18 118 -52
140 -95 23 -45 19 -128 -8 -174 -25 -41 -98 -96 -128 -96 -10 0 -21 -4 -24
-10 -4 -6 5 -10 21 -10 82 0 171 -60 200 -135 18 -49 16 -90 -10 -145 -11 -24
-14 -27 -11 -10 20 92 18 140 -10 176 -13 16 -12 13 1 -20 17 -42 12 -60 -9
-32 -12 16 -14 16 -26 2 -7 -9 -17 -13 -22 -10 -5 3 -9 -10 -9 -29 0 -76 -72
-178 -138 -197 -43 -11 -172 -13 -188 -2 -14 9 -22 69 -25 192 l-3 95 -6 -105
c-3 -58 -7 -87 -8 -65 -3 48 -23 78 -46 69 -9 -3 -17 -11 -17 -18 -1 -6 -5 3
-9 19 -4 17 -8 150 -9 297 -1 284 -3 298 -51 298 -10 0 -22 5 -25 10 -11 17
350 13 420 -5z m-8490 -376 c9 -28 15 -52 12 -55 -4 -4 -37 85 -37 100 0 18
11 0 25 -45z m-918 25 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m60 -50 c52 -19 120 -93 129 -141 8 -42 0 -111 -15 -126 -8 -8 -8 -1 -1 24 13
43 4 108 -21 148 -24 39 -102 90 -151 98 -21 3 -35 10 -32 15 6 9 24 6 91 -18z
m-280 0 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-25 -199 l3
-170 65 -3 c91 -4 121 3 168 44 23 20 42 31 42 26 0 -20 -71 -71 -112 -83 -43
-11 -156 -8 -177 5 -7 5 -11 67 -11 189 0 117 3 178 10 171 5 -5 11 -86 12
-179z m1705 143 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-973
-164 c-31 -71 -61 -133 -66 -139 -14 -13 -13 -11 56 144 32 72 60 130 62 128
2 -2 -22 -61 -52 -133z m973 49 c-2 -16 -4 -3 -4 27 0 30 2 43 4 28 2 -16 2
-40 0 -55z m283 12 c0 -5 -5 -3 -10 5 -5 8 -10 20 -10 25 0 6 5 3 10 -5 5 -8
10 -19 10 -25z m2661 8 c-12 -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6
-23z m-1221 -54 c26 -85 21 -103 -5 -22 -11 32 -23 62 -27 68 -11 12 -10 25 2
25 5 0 19 -32 30 -71z m7 49 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m-2507 5 l-126 -4 -37 -93 c-20 -52 -37 -103 -37 -114 0 -24 25 -52 46
-52 8 0 14 -5 14 -11 0 -11 -37 -3 -57 13 -21 17 -15 64 22 159 19 50 37 95
41 100 3 5 62 8 132 7 l127 -2 -125 -3z m4624 -133 l7 -25 -15 25 c-9 14 -15
19 -16 13 0 -23 -37 -14 -43 10 -2 12 -8 30 -12 40 -5 12 -3 17 8 17 8 0 18 8
22 18 5 13 11 7 25 -28 9 -25 20 -56 24 -70z m2030 35 c36 -89 141 -146 240
-131 32 5 57 19 90 47 29 26 44 34 39 22 -18 -50 -90 -92 -159 -93 -51 0 -117
23 -160 55 -27 21 -33 22 -38 9 -10 -27 -7 -42 12 -47 16 -4 16 -5 -1 -6 -20
-1 -40 42 -32 70 3 10 -1 41 -9 69 -19 62 -7 66 18 5z m-7287 -17 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m2644 -52 c-16 -36 -32 -66 -35
-66 -3 0 6 26 20 58 14 31 28 63 31 70 3 7 7 11 10 9 2 -3 -9 -35 -26 -71z
m6844 -33 c-55 -47 -64 -41 -13 10 24 23 45 38 47 32 2 -5 -13 -24 -34 -42z
m-4760 -59 c14 -3 25 -10 25 -14 0 -13 -44 1 -57 18 -7 9 -13 27 -12 41 1 24
2 23 10 -6 7 -22 17 -35 34 -39z m1040 26 c-7 -23 -63 -53 -79 -43 -5 3 6 11
25 17 19 6 38 21 44 33 12 27 19 22 10 -7z m1570 12 c-3 -3 -11 0 -18 7 -9 10
-8 11 6 5 10 -3 15 -9 12 -12z m-5945 0 c0 -18 -42 -52 -63 -52 -18 1 -16 3
11 15 18 8 35 21 38 30 7 16 14 20 14 7z m-1832 -24 c-9 -14 -26 -24 -44 -25
-18 -1 -21 1 -8 3 12 3 30 14 40 25 23 26 30 24 12 -3z m779 -3 c-15 -14 -38
-25 -50 -25 -15 0 -9 7 23 24 58 30 61 30 27 1z m4264 -6 c-13 -10 -33 -19
-45 -19 -18 0 -17 2 9 16 17 8 34 19 39 24 5 6 12 7 15 4 3 -3 -5 -14 -18 -25z
m-2021 -4 c-7 -8 -22 -15 -34 -14 -18 0 -17 2 7 11 15 5 27 15 27 21 0 5 3 7
6 4 4 -4 1 -13 -6 -22z m584 11 c-3 -7 -16 -18 -30 -25 -31 -14 -34 -14 -34
-1 0 6 8 10 19 10 10 0 24 7 31 15 15 19 21 19 14 1z m462 -14 c-8 -13 -56
-22 -56 -11 0 5 9 9 19 9 11 0 23 5 26 11 4 6 9 8 12 5 3 -2 2 -9 -1 -14z
m3234 3 c-7 -8 -24 -14 -39 -14 -20 1 -22 2 -6 6 11 3 24 9 30 14 15 15 28 10
15 -6z m2131 1 c-13 -15 -60 -30 -68 -22 -5 5 53 34 71 35 5 1 3 -5 -3 -13z
m-6881 -6 c-8 -5 -24 -9 -35 -9 -16 1 -16 2 5 9 35 11 48 11 30 0z m1828 3
c-16 -2 -40 -2 -55 0 -16 2 -3 4 27 4 30 0 43 -2 28 -4z m1228 -2 c-8 -12 -46
-21 -46 -11 0 5 8 11 18 13 29 8 33 7 28 -2z m4001 3 c-3 -3 -12 -4 -19 -1 -8
3 -5 6 6 6 11 1 17 -2 13 -5z m146 -1 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17
0 24 -2 18 -5z m-8433 -7 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14
25 6z m6627 -6 c-16 -5 -47 -5 -70 0 -38 7 -36 8 28 8 54 0 63 -2 42 -8z
m-2883 -587 l100 -103 -107 0 -107 0 -1 98 c-1 59 -4 87 -8 72 -4 -14 -13 -24
-18 -23 -6 1 -17 -5 -25 -14 -11 -14 -11 -16 2 -8 25 16 40 14 37 -3 -1 -10
-7 -17 -12 -17 -6 0 -9 3 -8 7 2 4 -7 6 -19 5 -12 -1 -40 -22 -64 -47 -45 -48
-53 -70 -9 -26 33 33 42 33 21 1 -19 -28 -11 -34 11 -7 8 9 12 12 9 6 -7 -14
15 -24 50 -24 13 0 24 -5 24 -10 0 -7 -36 -9 -95 -8 -52 2 -95 4 -95 6 0 8
203 203 209 200 3 -2 51 -49 105 -105z m-626 -85 c2 -10 -1 -18 -7 -18 -6 0
-11 4 -11 9 0 6 -610 9 -1622 7 -893 -2 -1589 -2 -1548 1 71 4 2344 18 2920
18 244 0 265 -1 268 -17z m3807 2 c312 -4 394 -7 235 -8 -894 -5 -2549 -6
-2380 -2 159 5 112 6 -209 7 -285 2 -419 -1 -428 -9 -10 -8 -13 -7 -13 4 0 8
3 18 7 22 8 8 1987 -2 2788 -14z m-4323 -17 c-62 -2 -161 -2 -220 0 -59 1 -8
3 113 3 121 0 169 -2 107 -3z m1936 0 c-21 -2 -57 -2 -80 0 -24 2 -7 4 37 4
44 0 63 -2 43 -4z"/>
<path d="M6050 10743 c-396 -38 -662 -98 -975 -220 -1240 -481 -2053 -1647
-2118 -3035 -2 -37 0 -69 4 -70 4 -2 12 -46 17 -98 l9 -95 2 130 c3 125 8 185
17 194 2 2 4 -97 4 -220 0 -216 19 -472 39 -534 5 -16 12 -55 15 -85 l5 -55
-19 59 c-11 33 -22 62 -25 65 -12 11 34 -180 54 -229 9 -21 10 -19 5 15 -3 22
-8 49 -11 60 -3 16 -2 17 6 5 6 -8 15 -36 22 -62 6 -29 15 -45 21 -41 7 4 9
-3 5 -18 -3 -13 -2 -42 3 -64 8 -36 7 -38 -6 -21 -8 11 -14 16 -14 10 1 -19
97 -294 101 -290 2 2 5 -6 5 -18 1 -12 15 -51 31 -86 17 -36 43 -94 59 -130
16 -36 41 -87 55 -115 78 -150 123 -232 136 -250 14 -19 15 -18 9 10 -3 17 -3
24 0 17 3 -6 10 -10 14 -7 5 3 14 -5 20 -17 11 -22 10 -22 -4 -4 -21 26 -21 7
0 -22 8 -12 12 -22 7 -22 -4 0 -3 -4 3 -8 6 -4 21 -22 32 -40 12 -20 23 -29
27 -23 3 6 11 9 16 5 5 -3 7 -10 3 -15 -3 -5 -10 -6 -16 -3 -7 4 -8 2 -4 -4 4
-7 14 -12 21 -12 8 0 12 -6 9 -14 -3 -7 1 -20 8 -28 7 -7 20 -27 29 -43 9 -17
21 -29 27 -28 7 2 9 -4 5 -14 -5 -12 -2 -15 10 -10 9 3 16 3 14 -1 -1 -4 9
-24 22 -45 46 -75 13 -45 -61 56 -113 151 -158 219 -151 230 3 6 1 7 -5 3 -5
-3 -13 0 -15 6 -4 10 -6 10 -6 1 -2 -24 266 -401 320 -452 13 -12 18 -24 14
-32 -5 -7 -4 -10 1 -7 5 3 20 -8 34 -25 44 -53 231 -237 241 -237 5 0 64 -42
132 -93 341 -261 653 -425 1032 -546 381 -121 604 -155 1010 -155 230 -1 293
3 425 22 567 84 1107 323 1570 696 119 95 397 380 494 506 354 458 579 945
685 1479 50 251 65 403 65 686 1 163 -4 314 -12 380 -62 520 -218 983 -475
1413 -291 486 -680 874 -1170 1164 -479 284 -1061 441 -1615 436 -97 0 -193
-3 -212 -5z m777 -69 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m60 -10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m159 -34 c155
-40 204 -55 289 -87 485 -182 862 -427 1222 -795 114 -115 178 -189 155 -174
-8 4 -32 29 -55 55 -442 492 -987 825 -1632 995 -71 19 -123 35 -114 35 8 1
69 -13 135 -29z m-1106 -19 c0 -4 41 -9 92 -10 108 -2 133 -11 32 -11 -252 -2
-682 -102 -996 -233 -60 -24 -108 -41 -108 -36 0 5 18 16 40 25 22 9 37 20 34
25 -3 5 -1 9 4 9 5 0 26 11 47 25 20 14 50 29 66 32 16 3 27 9 24 13 -2 4 39
20 93 35 53 16 102 32 107 36 6 4 42 14 80 23 39 8 102 22 140 31 39 8 76 13
83 10 7 -3 11 -1 8 3 -3 4 13 8 35 7 22 0 70 4 107 11 84 15 112 16 112 5z
m253 -8 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m346 -9 c8 -7
-134 -2 -164 6 -16 4 13 5 65 2 52 -3 97 -6 99 -8z m181 -19 c52 -9 137 -24
188 -35 51 -11 105 -18 120 -15 22 4 23 4 7 -4 -18 -8 -17 -9 10 -16 17 -4 65
-18 108 -32 43 -14 85 -22 93 -19 50 19 609 -232 589 -265 -3 -4 0 -11 6 -15
8 -4 9 -3 5 4 -11 18 5 14 43 -9 18 -11 31 -23 27 -26 -3 -3 -14 1 -24 10 -20
19 -37 23 -27 7 8 -13 66 -43 64 -33 -3 20 2 23 16 9 9 -8 23 -13 33 -10 16 5
15 5 -1 -6 -9 -6 -22 -8 -27 -5 -23 14 -7 -3 23 -25 30 -22 31 -22 13 -2 -30
34 -11 26 57 -24 34 -26 53 -44 42 -40 l-20 6 20 -15 c11 -8 26 -19 33 -25 8
-8 12 -8 12 0 0 12 55 -27 55 -38 0 -14 17 -32 48 -53 26 -17 25 -15 -8 15
-59 52 -32 44 31 -10 29 -25 51 -50 48 -55 -3 -5 -2 -9 3 -8 22 4 35 -2 30
-15 -5 -13 70 -96 88 -96 5 0 0 7 -11 15 -10 8 -14 15 -8 15 5 0 25 -16 44
-35 35 -36 32 -48 -4 -18 -16 13 -15 11 3 -9 13 -15 27 -25 31 -23 17 10 165
-149 154 -166 -3 -6 2 -19 12 -30 13 -15 19 -17 26 -7 6 9 8 7 6 -7 -2 -11 2
-19 9 -18 8 2 10 -4 6 -14 -4 -10 -2 -14 4 -10 12 7 39 -20 30 -29 -3 -4 18
-38 46 -78 386 -525 598 -1168 624 -1886 15 -443 -92 -998 -274 -1420 -118
-273 -292 -563 -473 -790 -167 -208 -454 -475 -666 -618 -395 -266 -865 -447
-1329 -512 -398 -55 -897 -13 -1297 111 -421 130 -783 324 -1113 599 -844 701
-1275 1788 -1149 2898 38 333 145 745 261 1001 13 29 22 55 20 57 -5 5 -45
-84 -82 -184 -15 -40 -29 -71 -32 -68 -2 2 0 13 5 23 6 10 7 34 3 53 l-7 34
-18 -47 c-10 -27 -20 -46 -23 -43 -17 17 144 381 235 529 19 31 36 57 37 57 2
0 1 -10 -2 -22 -4 -22 -4 -22 8 -3 18 28 49 60 49 50 0 -4 9 0 20 10 15 14 20
15 20 4 0 -8 13 5 28 27 73 111 168 235 237 309 l37 40 -34 -45 c-213 -277
-324 -452 -432 -682 -338 -719 -422 -1500 -241 -2257 139 -586 454 -1147 866
-1548 567 -549 1265 -857 2052 -904 908 -54 1826 332 2436 1024 664 754 958
1785 796 2792 -111 691 -435 1326 -924 1809 -55 55 -97 104 -94 109 3 6 1 7
-5 3 -6 -4 -46 22 -89 59 -166 139 -383 280 -593 386 -321 161 -620 252 -1015
308 -42 6 -50 9 -25 10 19 0 78 -6 130 -14z m430 -75 c62 -22 32 -19 -45 3
-27 9 -41 15 -30 15 11 1 45 -8 75 -18z m-2200 -190 c0 -5 -4 -10 -10 -10 -5
0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-130 -69 c-140 -78 -226
-130 -340 -209 -52 -36 -86 -55 -76 -44 10 12 62 49 115 83 53 34 112 72 131
85 56 36 254 144 265 144 5 0 -37 -26 -95 -59z m2075 -424 c205 -40 306 -72
445 -142 366 -183 565 -523 530 -905 -23 -239 -99 -398 -284 -589 -92 -94
-218 -190 -337 -256 -60 -33 -62 -34 -30 -7 l34 29 -31 14 c-18 8 -32 16 -32
19 0 3 18 16 40 29 22 14 38 26 36 29 -2 2 -22 -8 -43 -21 -64 -41 -244 -128
-267 -130 -11 -1 -46 -14 -76 -28 -128 -60 -337 -146 -465 -192 -144 -52 -346
-128 -505 -191 -102 -40 -219 -86 -260 -102 -41 -16 -78 -33 -82 -39 -4 -5 -8
-6 -8 -1 0 5 -8 2 -17 -6 -10 -9 -44 -25 -76 -37 -33 -12 -66 -28 -74 -37 -9
-8 -22 -13 -30 -10 -8 3 -11 2 -8 -4 3 -5 -13 -14 -35 -20 -22 -6 -40 -15 -40
-21 0 -6 -5 -7 -12 -3 -6 4 -17 -1 -25 -11 -7 -11 -13 -15 -13 -9 0 5 -3 5 -8
-1 -4 -5 -30 -22 -59 -36 -29 -15 -49 -30 -45 -34 4 -5 1 -5 -5 -1 -13 7 -71
-28 -128 -78 -16 -14 -34 -26 -38 -26 -8 0 -25 -13 -59 -45 -11 -11 -17 -14
-13 -7 16 28 -32 -7 -75 -55 -23 -26 -39 -41 -35 -33 23 44 -113 -106 -152
-167 -25 -40 -47 -73 -49 -73 -2 0 2 16 10 35 32 75 125 195 248 318 116 115
147 150 118 132 -12 -7 -11 -45 -15 485 -1 228 0 642 4 920 6 504 6 504 11
-415 l5 -920 3 1136 c1 724 -2 1156 -8 1190 -31 169 -168 281 -359 294 -46 3
-55 7 -58 25 l-3 21 1147 -4 c992 -3 1159 -6 1228 -20z m1495 -32 c25 -30 3
-25 -26 6 -22 24 -24 29 -8 21 11 -6 27 -18 34 -27z m449 -365 c440 -595 681
-1328 681 -2070 0 -187 -13 -331 -51 -560 -48 -292 -119 -539 -234 -815 -39
-94 -122 -265 -129 -265 -4 0 34 97 106 270 70 168 166 472 212 675 26 116 55
340 67 520 12 184 2 435 -26 665 -73 588 -305 1147 -678 1630 -71 93 -74 97
-48 75 12 -11 58 -67 100 -125z m-5592 -967 c-3 -10 -5 -2 -5 17 0 19 2 27 5
18 2 -10 2 -26 0 -35z m-60 -45 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m-70 -240 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-20
-70 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-10 -50 c-3 -7 -5
-2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-10 -50 c-3 -7 -5 -2 -5 12 0 14
2 19 5 13 2 -7 2 -19 0 -25z m-10 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3
4 -12 1 -19z m-20 -130 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m4316 -43 c454 -81 806 -335 1000 -722 96 -190 132 -361 131 -628 0 -301 -44
-499 -163 -735 -47 -92 -121 -210 -146 -230 -16 -12 -15 -9 3 17 24 34 28 48
10 37 -7 -4 -8 -3 -4 4 4 6 12 9 19 6 11 -4 69 85 66 103 -3 20 2 33 14 31 7
-2 11 6 9 22 -1 17 1 21 6 12 9 -13 37 43 77 151 26 69 12 69 -16 0 -12 -32
-26 -60 -30 -63 -3 -3 -18 -28 -32 -56 -51 -101 -164 -250 -269 -356 -59 -60
-113 -108 -119 -108 -8 0 -7 6 2 18 13 15 12 16 -3 3 -10 -7 -16 -17 -13 -21
10 -16 -187 -146 -277 -183 -58 -24 -45 -10 20 21 59 29 172 98 172 106 0 3
-41 -19 -91 -49 -50 -30 -131 -71 -179 -91 -49 -21 -86 -42 -83 -47 4 -6 1 -7
-6 -2 -16 9 -103 -14 -95 -26 3 -5 -1 -6 -9 -3 -8 3 -52 -4 -98 -16 -210 -54
-201 -53 -1516 -57 -673 -2 -1223 -7 -1223 -11 0 -4 28 -6 62 -5 l63 1 -64 -8
c-73 -10 -81 -8 -81 24 0 31 14 41 80 56 122 28 257 127 295 216 24 55 45 125
46 154 2 24 2 24 6 2 2 -12 9 -20 14 -17 5 4 9 107 10 238 0 128 4 250 8 272
5 22 9 32 10 23 1 -19 21 -26 21 -8 0 6 6 10 14 10 8 0 44 20 80 45 37 25 69
45 71 45 8 0 133 96 170 130 17 15 44 35 60 43 17 8 40 26 52 39 11 12 37 34
56 48 20 14 40 34 45 45 10 19 10 19 20 -5 9 -21 11 -15 12 40 1 36 5 85 9
110 l8 45 2 -45 c3 -55 18 -143 20 -115 2 20 2 20 16 1 14 -18 15 -17 17 25 5
129 16 -214 17 -526 1 -432 7 -465 90 -559 57 -63 190 -119 362 -153 136 -26
593 -26 724 0 219 45 432 163 588 327 107 112 173 208 243 354 81 168 160 483
157 621 -1 38 1 45 8 30 6 -13 8 20 4 98 -9 208 -84 495 -162 619 -13 21 -23
40 -23 44 0 3 -24 40 -52 82 -62 89 -167 196 -252 257 -129 91 -325 172 -443
182 -35 3 -63 8 -63 12 1 3 47 28 103 54 l102 48 115 -5 c63 -3 154 -12 203
-21z m-4326 -7 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m3756
-120 c-105 -164 -287 -360 -468 -504 -164 -130 -429 -301 -775 -499 -594 -340
-859 -557 -1073 -880 -148 -224 -235 -487 -238 -720 l0 -70 -19 53 c-82 231
-83 545 -1 803 68 216 191 430 360 629 268 314 614 526 1351 827 526 215 715
301 833 377 29 18 53 32 55 31 2 -2 -10 -22 -25 -47z m-3776 -30 c-3 -7 -5 -2
-5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m40 -235 c-2 -16 -4 -5 -4 22 0 28 2
40 4 28 2 -13 2 -35 0 -50z m0 -235 c-2 -24 -4 -5 -4 42 0 47 2 66 4 43 2 -24
2 -62 0 -85z m10 -125 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z
m20 -175 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m10 -70 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m30 -160 c-3 -8 -6 -5 -6 6 -1
11 2 17 5 13 3 -3 4 -12 1 -19z m32 -133 c0 -5 -3 -3 -6 5 -3 8 -11 22 -18 30
-8 9 -11 27 -7 45 5 29 6 28 19 -20 7 -27 12 -54 12 -60z m-12 -57 c-3 -7 -5
-2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m62 -187 c-10 -30 -13 -32 -19 -16
-14 40 -20 86 -10 80 6 -3 10 -17 10 -31 0 -15 4 -23 11 -19 6 4 8 21 5 38 -6
29 -5 30 4 8 7 -17 7 -35 -1 -60z m30 -31 c0 -10 -3 -8 -9 5 -12 27 -12 43 0
25 5 -8 9 -22 9 -30z m8 -122 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m78 -106 c-5 -5 -18 26 -29 68 -3 14 3 5 14 -19 11 -24 18 -46 15 -49z
m-31 5 c-4 -14 -3 -17 6 -12 9 5 11 4 6 -4 -12 -18 -28 -2 -20 21 4 14 2 18
-5 14 -6 -4 -11 -3 -11 3 0 5 -3 18 -7 28 -4 13 -1 12 16 -6 14 -16 19 -31 15
-44z m104 -152 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m-14
-11 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m30 -84 c10 -22
22 -40 28 -40 5 0 8 -6 5 -12 -2 -7 0 -21 5 -30 5 -12 5 -18 -2 -18 -5 0 -10
6 -10 13 0 6 -13 38 -29 70 -16 31 -26 57 -22 57 4 0 15 -18 25 -40z m40 -6
c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m35 -79 c0 -5 -6 1
-14 15 -8 14 -14 30 -14 35 0 6 6 -1 14 -15 8 -14 14 -29 14 -35z m71 -105 c6
-11 8 -20 6 -20 -3 0 -10 9 -16 20 -6 11 -8 20 -6 20 3 0 10 -9 16 -20z m4610
-113 c0 -2 -12 -14 -27 -28 l-28 -24 24 28 c23 25 31 32 31 24z m-4396 -186
c3 -5 -2 -15 -12 -22 -15 -12 -16 -12 -5 2 7 9 10 19 6 22 -3 4 -4 7 0 7 3 0
8 -4 11 -9z m523 -93 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m-21 -94 c-8 -38 -15 -59 -15 -47 -1 26 19 126 25 121 2 -2 -3 -35 -10 -74z
m-431 19 c37 -46 27 -41 -20 8 -22 23 -33 38 -24 33 9 -5 29 -24 44 -41z m66
-80 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z m348 -45 c0
-27 -2 -29 -8 -13 -5 11 -6 26 -4 33 8 21 13 13 12 -20z m1434 -65 c-40 -2
-107 -2 -150 0 -43 1 -10 3 72 3 83 0 118 -2 78 -3z m-1416 -199 c-4 -4 6 -18
21 -32 29 -27 32 -28 -36 12 -14 8 -7 26 10 26 6 0 8 -3 5 -6z m198 -165 c16
-19 13 -18 -17 5 -21 16 -38 30 -38 33 0 8 36 -16 55 -38z"/>
<path d="M7276 10436 c50 -22 82 -27 39 -7 -22 11 -47 20 -55 20 -8 0 -1 -6
16 -13z"/>
<path d="M7399 10389 c24 -11 46 -18 48 -15 4 4 -73 36 -85 35 -4 0 13 -9 37
-20z"/>
<path d="M7490 10353 c65 -33 110 -53 110 -48 0 7 -90 51 -120 59 -17 4 -13 1
10 -11z"/>
<path d="M7740 10231 c14 -11 30 -21 35 -21 11 0 -7 14 -40 31 -13 7 -12 3 5
-10z"/>
<path d="M8047 10039 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M8140 9976 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M8520 9625 c97 -107 110 -120 110 -112 0 10 -108 128 -134 146 -12 8
-1 -7 24 -34z"/>
<path d="M3562 9114 c-7 -15 -17 -22 -24 -18 -7 4 -8 3 -4 -4 4 -6 2 -21 -4
-32 -6 -11 -9 -20 -6 -20 7 0 58 91 54 96 -3 2 -10 -7 -16 -22z"/>
<path d="M3360 8839 c-7 -11 -10 -23 -7 -25 2 -2 9 7 15 21 14 30 7 33 -8 4z"/>
<path d="M3386 8783 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M3301 8713 c-20 -39 -40 -93 -31 -88 5 3 14 22 20 41 9 27 15 33 21
23 6 -10 9 -6 9 14 0 31 -5 34 -19 10z"/>
<path d="M3302 8650 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5763 9671 c-97 -12 -127 -65 -113 -192 6 -48 10 -491 10 -1032 0
-522 3 -947 8 -945 4 2 52 25 107 51 55 27 154 71 220 100 161 69 433 204 520
257 327 200 534 446 620 735 60 201 65 316 20 470 -36 125 -82 203 -181 311
-118 127 -324 218 -547 243 -101 12 -575 13 -664 2z m1188 -348 c83 -89 139
-185 175 -303 27 -88 13 -84 -16 5 -41 123 -92 211 -174 296 -38 39 -60 67
-50 61 11 -6 40 -32 65 -59z"/>
<path d="M7668 8423 c-33 -49 -186 -208 -268 -278 -25 -22 -44 -42 -43 -45 1
-3 -4 -12 -11 -20 -26 -30 -25 -36 5 -34 16 1 26 -2 23 -7 -3 -5 -10 -6 -16
-3 -6 4 -8 2 -4 -4 3 -5 -6 -20 -21 -32 -48 -36 10 -4 83 47 121 84 219 188
300 318 14 23 15 27 3 18 -9 -7 -19 -10 -23 -6 -4 4 -4 0 -1 -9 4 -9 3 -18 -2
-21 -13 -8 -9 75 5 101 22 39 4 24 -30 -25z m3 -36 c-10 -9 -11 -8 -5 6 3 10
9 15 12 12 3 -3 0 -11 -7 -18z"/>
<path d="M7335 8123 c-68 -50 -203 -131 -302 -182 -46 -24 -83 -45 -83 -47 0
-3 3 -4 8 -2 4 2 21 10 37 18 135 64 433 254 393 250 -2 0 -25 -17 -53 -37z"/>
<path d="M7314 8078 l-19 -21 28 18 c28 18 33 25 19 25 -5 0 -17 -10 -28 -22z"/>
<path d="M7262 8011 c-11 -7 -10 -9 3 -14 9 -4 14 -3 10 2 -3 5 1 12 7 14 7 3
9 6 3 6 -5 0 -16 -3 -23 -8z"/>
<path d="M8416 5985 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M8401 5934 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7989 5353 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7855 5244 l-30 -26 33 22 c17 12 32 23 32 26 0 7 -4 5 -35 -22z"/>
<path d="M4539 6393 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M4504 6348 c-61 -69 -167 -246 -217 -363 -50 -117 -74 -196 -98 -325
-29 -153 -24 -366 12 -510 l24 -95 7 75 c31 308 162 597 390 860 39 45 63 78
52 72 -10 -5 -29 -8 -42 -6 -16 3 -21 0 -16 -8 4 -7 3 -8 -4 -4 -7 4 -12 13
-12 20 0 7 -9 21 -20 31 -11 10 -20 30 -20 45 0 16 -6 30 -14 33 -8 3 -22 23
-32 44 -10 21 -23 45 -31 54 -11 14 -11 18 2 29 8 7 15 9 15 5 0 -4 7 -2 15 5
8 7 15 17 15 22 0 6 -7 5 -15 -2 -20 -17 -19 -1 2 22 9 10 14 18 11 18 -2 0
-13 -10 -24 -22z m80 -318 c-6 -6 -10 -3 -10 10 0 13 4 16 10 10 7 -7 7 -13 0
-20z m59 5 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-33 -38
c0 -2 -12 -14 -27 -28 -15 -13 -22 -17 -15 -8 6 9 8 20 4 24 -4 5 -2 5 5 1 6
-3 14 -2 18 4 6 10 15 14 15 7z"/>
<path d="M3902 9927 c-20 -21 -20 -23 -2 -23 10 0 16 4 13 9 -2 4 1 14 7 22
20 24 6 17 -18 -8z"/>
<path d="M3826 9843 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M3915 9800 c-21 -22 -37 -40 -34 -40 3 0 24 18 47 40 22 22 37 40 33
40 -4 0 -25 -18 -46 -40z"/>
<path d="M3791 9813 c-7 -8 -11 -16 -8 -19 2 -2 10 2 17 11 17 20 9 27 -9 8z"/>
<path d="M3712 9726 c-45 -47 -51 -59 -27 -49 14 5 82 93 72 93 -1 0 -22 -20
-45 -44z"/>
<path d="M3841 9719 c-18 -16 -31 -32 -29 -34 2 -3 20 11 38 30 42 43 36 46
-9 4z"/>
<path d="M3735 9711 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M3640 9599 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3590 9541 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M2963 7110 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M3002 6930 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3011 6714 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3021 6664 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8933 5358 c-19 -25 -35 -61 -24 -54 6 4 18 20 26 37 16 30 15 38 -2
17z"/>
<path d="M8871 5272 c-7 -13 -6 -19 2 -19 7 0 13 9 13 19 0 10 -1 18 -3 18 -1
0 -7 -8 -12 -18z"/>
<path d="M8920 5193 c-53 -80 -50 -82 9 -5 18 23 29 42 24 42 -4 0 -19 -17
-33 -37z"/>
<path d="M8825 5074 c-23 -36 -15 -37 13 -3 13 16 19 29 14 29 -5 0 -17 -12
-27 -26z"/>
<path d="M9417 2964 c17 -16 38 -42 47 -59 8 -16 15 -25 16 -19 0 18 -43 76
-70 92 -20 11 -18 8 7 -14z"/>
<path d="M1320 3390 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M1552 3389 c7 -5 36 -8 63 -8 60 1 50 6 -23 12 -32 2 -48 1 -40 -4z"/>
<path d="M1434 3354 c3 -9 6 -83 6 -166 l0 -151 65 5 c122 10 177 58 183 162
8 119 -42 166 -178 166 -71 0 -81 -2 -76 -16z"/>
<path d="M1700 3366 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z"/>
<path d="M1760 3316 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M1710 3268 c0 -23 3 -29 9 -19 8 12 4 51 -5 51 -2 0 -4 -15 -4 -32z"/>
<path d="M1801 3224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2470 3365 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M2451 3214 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2360 3198 c0 -3 -7 -22 -15 -42 -8 -20 -13 -36 -10 -36 8 0 36 73
30 78 -3 3 -5 3 -5 0z"/>
<path d="M2305 3061 c-9 -22 -15 -45 -12 -53 4 -8 6 -7 6 5 1 10 8 32 17 48 8
17 14 33 11 35 -2 2 -12 -13 -22 -35z"/>
<path d="M4866 3017 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M6604 3077 c-38 -95 -69 -176 -69 -180 0 -4 66 -9 147 -10 144 -2
148 -1 142 18 -4 11 -10 25 -14 30 -3 6 -14 33 -24 60 -29 83 -98 245 -106
250 -4 2 -38 -73 -76 -168z"/>
<path d="M6846 3097 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M6860 3065 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M6602 2863 c37 -2 100 -2 140 0 40 1 10 3 -67 3 -77 0 -110 -1 -73
-3z"/>
<path d="M6451 2784 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8292 3073 l-71 -178 147 -5 c81 -3 148 -5 150 -4 5 2 -136 346 -146
356 -6 6 -36 -58 -80 -169z"/>
<path d="M8610 2919 c0 -4 9 -26 20 -50 11 -24 19 -37 19 -29 0 15 -38 91 -39
79z"/>
<path d="M8333 2863 c31 -2 83 -2 115 0 31 2 5 3 -58 3 -63 0 -89 -1 -57 -3z"/>
<path d="M8137 2765 c-24 -50 -20 -58 4 -12 11 22 19 41 17 43 -3 2 -12 -12
-21 -31z"/>
<path d="M8111 2684 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10351 2735 c-13 -25 -28 -45 -33 -45 -5 0 -6 -5 -3 -10 4 -6 14 -1
24 12 26 33 53 88 44 88 -5 0 -19 -20 -32 -45z"/>
<path d="M10872 3208 l3 -163 38 -3 c105 -9 199 55 212 142 18 120 -47 185
-188 186 l-67 0 2 -162z"/>
<path d="M11083 3074 c-17 -19 -27 -34 -22 -34 13 0 59 46 59 60 0 13 1 13
-37 -26z"/>
<path d="M11087 2999 c6 -6 30 -15 53 -19 23 -4 38 -4 33 1 -4 4 -20 9 -35 11
-15 2 -30 7 -34 11 -4 4 -12 7 -18 7 -6 0 -6 -4 1 -11z"/>
<path d="M10872 2818 l3 -183 70 -3 c116 -5 181 25 216 102 32 71 22 154 -24
205 -39 42 -94 61 -185 61 l-82 0 2 -182z"/>
<path d="M11214 2878 c0 -10 1 -18 3 -18 1 0 7 8 12 18 7 13 6 19 -2 19 -7 0
-13 -9 -13 -19z"/>
<path d="M7643 1903 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
</g>
</svg>


    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
